/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import { Auth } from '../../../modules/auth/Auth';

import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import GridContainer from 'components/Grid/GridContainer.jsx';
import Card from 'components/Card/Card.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import CardBody from '../../../components/Card/CardBody';
import ChangeButton from '../../../components/Buttons/CustomTextButton';
import MsisdnPoolChooseDialog from '../../msisdn-pools/Dialog/MsisdnPoolChooseDialog';
import { notificationConstants } from '../../../modules/notifications/notifications';
import { simCardActions, simCardConstants } from '../../../modules/simcard/actions';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';

class SimCardChangeMsisdn extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            new_msisdn: null,
            new_uri: null,
            openMsisdn: false,
            showAccept: false,
            showChoose: true,
            simCard: this.props.item,
        };
    }

    openGetMsisdnDialog = () => {
        this.setState({ openMsisdn: true });
    };

    closeGetMsisdnDialog = () => {
        this.setState({ openMsisdn: false });
    };

    callBackSetMsisdn = (v) => {
        this.setState({ showAccept: true, new_msisdn: v.msisdn, new_uri: v.uri }, this.closeGetMsisdnDialog);
    };

    callChangeButton = () => {
        const { dispatch } = this.props;
        if (this.state.new_msisdn === null) {
            dispatch({
                ...this.state,
                type: notificationConstants.CUSTOM_NOTIFY,
                message: 'error:sim_card.empty_msisdn_number',
                variant: 'error',
            });
            return;
        }
        const params = {
            msisdn: this.state.new_msisdn,
            simCardId: this.state.simCard.id,
        };
        dispatch(
            simCardActions.post(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_change_msisdns')),
                params,
                simCardConstants.SIM_CARD_CHANGE_MSISDN_REQUEST,
                () => {
                    dispatch({
                        ...this.state,
                        type: notificationConstants.CUSTOM_NOTIFY,
                        message: 'error:sim_card.wait_to_change_msisdn',
                        variant: 'success',
                    });
                    this.setState({
                        showAccept: false,
                        showChoose: false,
                    });
                }
            )
        );
    };

    render() {
        const { new_msisdn, showAccept, showChoose, simCard } = this.state;
        return (
            <Card>
                <CardBody>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Typography variant="subtitle1">
                                <I18n trans="simcard:edit.change_msisdn" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2">
                                <I18n trans="simcard:edit.new_msisdn_number" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2">{new_msisdn}</Typography>
                        </GridItem>
                        <GridItem xs={12}>
                            {showChoose && (
                                <ChangeButton
                                    callback={this.openGetMsisdnDialog}
                                    callbackParam={{}}
                                    label="simcard:edit.choose_new_msisdn"
                                    size="sm"
                                />
                            )}
                            {showAccept === true && (
                                <ChangeButton
                                    callback={this.callChangeButton}
                                    callbackParam={{}}
                                    label="simcard:edit.change"
                                    size="sm"
                                />
                            )}
                            <MsisdnPoolChooseDialog
                                callBackSetMsisdn={this.callBackSetMsisdn}
                                open={this.state.openMsisdn}
                                callbackClose={this.closeGetMsisdnDialog}
                                platformResellerId={simCard.client ? simCard.client.platformResellerId : Auth.getUserPlatformResellerId()}
                            />
                        </GridItem>
                    </GridContainer>
                </CardBody>
            </Card>
        );
    }
}

SimCardChangeMsisdn.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(SimCardChangeMsisdn);
export default Enhance;
